(function($){
    $(document).ready(function () {
        function scrollInit(scroll){
            let bar = $('#wpadminbar');
            let header = $('header');
            let banner = $('.banner');

            if (scroll.scrollTop() > 0) {
                let top = (bar.length && bar.css('position') === 'fixed') ? bar.outerHeight() : 0;
                banner.addClass('scrolled');
                header.css('top', top);
                header.addClass('fixed');
            } else {
                banner.removeClass('scrolled');
                header.css('top', 0);
                header.removeClass('fixed');
            }
        }
        scrollInit($(window));

        $(window).scroll(function () {
            scrollInit($(this));
        });
        $(window).resize(function () {
            scrollInit($(this));
        });

        $('.header_menu a').click(function(){
            if($(window).outerWidth() > 1200) return;

            $('.header_menu').fadeToggle(400);
        });
    });
})(jQuery)
